import {z} from 'zod';
import {getCellsThatNeedToBeSanitizedResponseSchema} from '../sanitizeValuesTool.schemas';

function buildSanitizeValuesToolResponse(
  cellsThatNeedToBeSanitized: z.infer<typeof getCellsThatNeedToBeSanitizedResponseSchema>,
): string {
  const {cellValueOverrides, unresolvedCells} = cellsThatNeedToBeSanitized;

  const howToResolve = `1. Give the user a numbered list of cells that are ambiguous, in this format:
**<value>** (<column-header>) in <row <row> OR rows <row number>-<row number>, ...> - did you mean <fixed value>?
2. Note that:
   2.1. row numbers are 1-indexed and rowIndex is 0-indexed.
   2.2. the <fixed value> should include the year, and be spelled out such as "February 4, 2025".
3. The <fixed value> you suggest should be one of the following:
   3.1. For dates such as 4.18, where it's impossible for 18 to be a month, interpret it in the only valid way, such as April 18.
   3.2. For dates such as 4.2, which could be interpreted as April 2 or Feb 4, assume the dates are in a <month>.<day> format.
4. If the user hasn't resolved ALL the ambiguous cells, repeat the process for the remaining ambiguous cells until they have.
5. Tell the user that they can also update the excel file and upload it again.
`;
  const responseObject = {
    cellValueOverrides,
    unresolvedCells,
    howToResolve,
  };

  return JSON.stringify(responseObject);
}

export default buildSanitizeValuesToolResponse;
